import {SiteSlug} from "@pg-mono/km-routes";

import {useMatchedSite} from "../features/km_app/hooks/use_matched_site";

export const getSiteSource = (slug: SiteSlug) => {
    switch (slug) {
        case SiteSlug.RP:
            return "rp";
        case SiteSlug.GH:
            return "gh";
        case SiteSlug.KM:
            return "km";
    }
};

export const useSiteSource = () => {
    const matchedSite = useMatchedSite();

    return getSiteSource(matchedSite);
};
import {SiteSlug} from "@pg-mono/km-routes";

import {useMatchedSite} from "../features/km_app/hooks/use_matched_site";

export const getSiteSource = (slug: SiteSlug) => {
    switch (slug) {
        case SiteSlug.RP:
            return "rp";
        case SiteSlug.GH:
            return "gh";
        case SiteSlug.KM:
            return "km";
    }
};

export const useSiteSource = () => {
    const matchedSite = useMatchedSite();

    return getSiteSource(matchedSite);
};
